import React, { useReducer, useCallback } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import CopilotSidebarAgentsForm from './CopilotSidebarAgentsForm';
import CopilotSidebarAgentsRemoteForm from './CopilotSidebarAgentsRemoteForm';
import CopilotSidebarAgentsList from './CopilotSidebarAgentsList';
import { createAgent, updateAgent, createA2A } from 'lib/services/copilotAgents';

import styles from './styles';
const useStyles = createUseStyles(styles, 'CopilotSidebarAgents');

const INITIAL_STATE = {
    step: 'list',
    agent: null,
};

const REDUCER = (state, action) => {
    switch (action.type) {
        case 'LIST_STEP':
            return { ...state, step: 'list', agent: null };
        case 'NEW_AGENT':
            return { ...state, step: 'custom-form', agent: null };
        case 'NEW_REMOTE_AGENT':
            return { ...state, step: 'remote-form', agent: null };
        case 'EDIT_AGENT':
            return { ...state, step: 'custom-form', agent: action.payload };
        case 'EDIT_REMOTE_AGENT':
            return { ...state, step: 'remote-form', agent: action.payload };
        default:
            return state;
    }
};

const CopilotSidebarAgentsTab = () => {
    const classes = useStyles();
    const [state, dispatch] = useReducer(REDUCER, INITIAL_STATE);

    const onNewAgent = useCallback(
        (type) => {
            if (!type || type === 'custom') {
                dispatch({ type: 'NEW_AGENT' });
            } else if (type === 'a2a') {
                dispatch({ type: 'NEW_REMOTE_AGENT' });
            }
        },
        [dispatch],
    );

    const onSaveAgent = (form) => {
        let promise;
        if (form.id) {
            promise = updateAgent(form);
        } else {
            if (form.url) {
                promise = createA2A(form.url);
            } else {
                promise = createAgent(form);
            }
        }

        return promise;
    };

    const onCancelAgent = useCallback(() => {
        dispatch({ type: 'LIST_STEP' });
    }, [dispatch]);

    const onUpdateAgent = useCallback(
        (agent) => {
            if (agent.type === 'custom' || !agent.type) {
                dispatch({ type: 'EDIT_AGENT', payload: agent });
            } else if (agent.type === 'a2a') {
                dispatch({ type: 'EDIT_REMOTE_AGENT', payload: agent });
            }
        },
        [dispatch],
    );

    return (
        <div className={classes.root}>
            {state.step === 'list' && (
                <CopilotSidebarAgentsList
                    key="copilot-sidebar-agents-list"
                    createAgent={onNewAgent}
                    updateAgent={onUpdateAgent}
                />
            )}
            {state.step === 'custom-form' && (
                <CopilotSidebarAgentsForm
                    key="copilot-sidebar-agents-custom-form"
                    agent={state.agent}
                    onCancel={onCancelAgent}
                    onSave={onSaveAgent}
                />
            )}
            {state.step === 'remote-form' && (
                <CopilotSidebarAgentsRemoteForm
                    key="copilot-sidebar-agents-remote-form"
                    agent={state.agent}
                    onCancel={onCancelAgent}
                    onSave={onSaveAgent}
                />
            )}
        </div>
    );
};

export default CopilotSidebarAgentsTab;
